import * as constants from "../constants.js";
import notifications from "../notifications.js";


export default {
    OnSuccess(description) {
        notifications.Success("Propostas", description, constants.NOTIFICATION_SUCCESS_MESSAGE_TIMEOUT);
    },

    OnWarning(resp, description) {
        notifications.Warning("Propostas", description);
        console.log(resp);
    },

    OnError(resp, description) {
        notifications.Error("Propostas", description);
        console.log(resp);
    },

    OnUnauthorized(){
        window.location = "/";
    },

    SearchCarMatchUsedRequests: async function (size, num, orderDirection, orderBy, searchTerm, status, matching) {
        let reqUri = `${constants.API_ENDPOINT_CARMATCHUSED}/requests/${size}/${num}`;
        let reqUriParams = '';

        if (orderDirection) {
            reqUriParams += `orderDirection=${orderDirection}&`;
        }
        
        if (orderBy) {
            reqUriParams += `orderBy=${orderBy}&`;
        }

        if (searchTerm) {
            reqUriParams += `searchTerm=${encodeURI(searchTerm)}&`;
        }

        if (status != null && status != undefined) {
            reqUriParams += `status=${status}&`;
        }

        if (matching != null && matching != undefined) {
            reqUriParams += `matching=${matching}&`;
        }

        // Remove the trailing '&' if any
        reqUriParams = reqUriParams.replace(/&$/, '');

        let result = await fetch(`${reqUri}?${reqUriParams}`, {
            method: constants.HTTP_METHOD_GET
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status >= 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao pesquisar as Propostas");
                        return null;
                    } else if (resp.status == 400) {
                        this.OnWarning(resp, "Existem incoerrências com os dados");
                    } else if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                }

                return resp.json();
            });

        return result;
    },

    UnlockContacts : async function(idCarMatchUsedRequest){
        let reqUri = `${constants.API_ENDPOINT_CARMATCHUSED}/requests/${idCarMatchUsedRequest}/unlockContacts`;
        let result = await fetch(reqUri, {
            method: constants.HTTP_METHOD_POST
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status >= 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao desbloquear os contactos");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                } else {
                    if (resp.status == 200) {
                        this.OnSuccess("Contactos desbloqueados com sucesso!");
                    }
                }

                return resp.json();
            });

        return result;
    },

    GetCarMatchUsedRequest: async function (idCarMatchUsedRequest, searchTerm) {
        let reqUri = `${constants.API_ENDPOINT_CARMATCHUSED}/requests/${idCarMatchUsedRequest}`;
        let reqUriParams = '';

        if (searchTerm != null && searchTerm != "")
            reqUriParams += `?searchTerm=${encodeURI(searchTerm)}`;


        let result = await fetch(`${reqUri}${reqUriParams}`, {
            method: constants.HTTP_METHOD_GET
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status >= 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao carregar a Proposta");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                }

                return resp.json();
            });

        return result;
    },

    GetRelatedAds: async function (idCarMatchUsedRequest, size, num, searchTerm) {
        let reqUri = `${constants.API_ENDPOINT_CARMATCHUSED}/requests/${idCarMatchUsedRequest}/relatedAds/${size}/${num}`;
        let reqUriParams = '';

        if (searchTerm != null && searchTerm != "")
            reqUriParams += `?searchTerm=${encodeURI(searchTerm)}`;

        let result = await fetch(`${reqUri}${reqUriParams}`, {
            method: constants.HTTP_METHOD_GET
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status >= 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao carregar os Anúncios Relacionados");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                }

                return resp.json();
            });

        return result;
    },
    
    UpdateReaded: async function (idRequest, showMessage) {
        let reqUri = `${constants.API_ENDPOINT_CARMATCHUSED}/requests/${idRequest}/read`;
        let result = await fetch(reqUri, {
            method: constants.HTTP_METHOD_POST
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status >= 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao atualizar o estado do pedido de proposta");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                } else {
                    if (resp.status == 200) {
                        if (showMessage) {
                            this.OnSuccess("Atualizado com sucesso!");
                        }
                    }
                }


                return resp.json();
            });

        return result;
    },

    DeleteCarMatchUsedRequestAdvertiser: async function (idCarMatchUsedRequest) {
        let reqUri = `${constants.API_ENDPOINT_CARMATCHUSED}/requests/${idCarMatchUsedRequest}`;
        let result = await fetch(reqUri, {
            method: constants.HTTP_METHOD_DELETE
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status >= 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao eliminar a Proposta");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                } else {
                    if (resp.status == 200) {
                        this.OnSuccess("Proposta eliminada com sucesso!");
                    }
                }

                return resp.json();
            });

        return result;
    },
    
    UpdateAsRejected: async function (idRequest, showMessage) {
        let reqUri = `${constants.API_ENDPOINT_CARMATCHUSED}/requests/${idRequest}/reject`;
        let result = await fetch(reqUri, {
            method: constants.HTTP_METHOD_POST
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status >= 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao atualizar o estado do pedido de proposta");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                } else {
                    if (resp.status == 200) {
                        if (showMessage) {
                            this.OnSuccess("Atualizado com sucesso!");
                        }
                    }
                }


                return resp.json();
            });

        return result;
    },
    
    CreateResponse: async function (idRequest, formData) {
        let reqUri = `${constants.API_ENDPOINT_CARMATCHUSED}/requests/${idRequest}/response`;
        let result = await fetch(reqUri, {
            method: constants.HTTP_METHOD_POST,
            headers: constants.HTTP_HEADERS_JSON,
            body: JSON.stringify(formData)
        })
            .then(resp => {
                if (!resp.ok) {
                    if (resp.status >= 500) {
                        this.OnError(resp, "Ocorreu uma anomalia ao enviar a Proposta");
                        return null;
                    }
                    if(resp.status == 401){
                        this.OnUnauthorized();
                        return null;
                    }
                } else {
                    if (resp.status == 200) {
                        this.OnSuccess("Proposta enviada com sucesso");
                    }
                }

                return resp.json();
            });

        return result;
    },
}